<template>
  <div class="pa-4">
    <h1>Async</h1>
    <p>如果有六个异步任务，需要全部完成后，才能执行最后的print函数。请问应该如何安排操作流程？</p>
    <p>如何确定异步操作执行的顺序，以及如何保证遵守这种顺序</p>
    <textarea
      v-model="msg"
      rows="10"
      readonly
      placeholder="输出结果"
      class="rounded pa-2"
      style="width: 100%;border: 1px solid lightblue;"
    />
    <div>
      <v-btn
        class="mr-2"
        @click="reset(),handleClick()"
      >
        按钮
      </v-btn>
      <v-btn
        class="mr-2"
        @click="reset(),serialFn()"
      >
        串行函数
      </v-btn>
      <v-btn
        class="mr-2"
        @click="reset(),parallelFn()"
      >
        并行函数
      </v-btn>
      <v-btn
        class="mr-2"
        @click="reset(),serialAndParallel()"
      >
        串行并行结合
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '',
    }
  },

  methods: {
    asyncFn(arg, callback) {
      this.msg += '执行中... 参数:' + arg + '\n';
      console.log('执行中... 参数:', arg);
      setTimeout(() => {
        callback(arg * 2);
      }, 500)
    },

    // 解构打印
    print(...args) {
      console.log(...args);
      this.msg += args.join(' ')+ '\n';
    },

    reset() {
      this.msg = '';
    },

    handleClick() {
      this.asyncFn(2, () => {
        this.asyncFn(4, () => {
          this.asyncFn(23, () => {
            this.asyncFn(12, () => {
              this.asyncFn(34, () => {
                this.asyncFn(64, (arg) => {
                  this.print(arg);
                });
              });
            });
          });
        });
      });
    },

    serialFn() {
      const that = this;
      // 定义参数序列
      let args = [1, 2, 3, 4, 5, 6];
      // 定义结果序列
      let results = [];
      // 结果处理函数
      function _handler(result) {
        results.push(result);
        _series(args.shift());
      }
      // 串行函数
      function _series(item) {
        if(item) {
          return that.asyncFn(item, _handler);
        } else {
          that.print('最终结果:', results[results.length - 1], '结果序列:', results);
        }
      }

      _series(args.shift());
    },

    // 并行执行的效率较高，比起串行执行一次只能执行一个任务，较为节约时间。但是问题在于如果并行的任务较多，很容易耗尽系统资源，拖慢运行速度。
    parallelFn() {
      // 定义参数序列
      let args = [1, 2, 3, 4, 5, 6];
      // 定义结果序列
      let results = [];

      // 并行函数
      args.forEach(item => {
        this.asyncFn(item, (result) => {
          results.push(result);
          if(args.length === results.length) {
            this.print('最终结果:', results[results.length - 1], '结果序列:', results);
          }
        })
      })
    },

    // 限制并行执行的数量，防止系统资源耗尽
    serialAndParallel() {
      const that = this;
      let args = [1, 2, 3, 4, 5, 6];
      let results = [];
      let running = 0;
      let max = 2; // 调整这个参数可以控制并行执行的数量，以优化系统资源
      function _launcher() {
        while (running < max && args.length > 0) {
          const item = args.shift();
          that.asyncFn(item, (result) => {
            console.log('并行执行完了 参数:', item, '结果:', result, '并行执行数量:', running);
            results.push(result);
            running-=1;
            if(args.length > 0) {
              _launcher();
            } else if(running === 0) {
              that.print('最终结果:', results[results.length - 1], '结果序列:', results);
            }
          })
          running+=1;
        }
      }

      _launcher();
    },
  }
}
</script>

<style>

</style>